export default "__VITE_ASSET__C7qtrr2$__"